import { Link } from '@tanstack/react-router';

export function AppNotFoundScreen() {
  return (
    <main className="landing-page">
      <section className="landing-hero">
        <h1 className="landing-title">Page not found</h1>
        <Link className="landing-primary-cta" to="/">
          Return Home
        </Link>
      </section>
    </main>
  );
}
